import { useQuery } from '@tanstack/react-query';

// Utils
import API from '../../../../utils/api';

export const useBitsoClabe = () => {
  return useQuery(
    ['/bitso-clabe'],
    async () => {
      const { data } = await API.getBitsoClabe();
      return data?.userClabe ?? null;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
};